import React, { useState } from 'react';

interface OpeningHoursExceptionsProps {
  todaysExceptionStrings?: string[];
  exceptionStrings?: string[][];
  showMoreText?: string;
  showLessText?: string;
}
export const OpeningHoursExceptions = ({
  todaysExceptionStrings,
  exceptionStrings,
  showMoreText,
  showLessText,
}: OpeningHoursExceptionsProps) => {
  const [showAll, setShowAll] = useState(false);

  if (todaysExceptionStrings) {
    return <h2 className="mb-2">{todaysExceptionStrings}</h2>;
  } else if (exceptionStrings) {
    let displayedExceptions;
    if (showAll) {
      displayedExceptions = exceptionStrings;
    } else {
      displayedExceptions = exceptionStrings.slice(0, 2);
    }
    return (
      <>
        {displayedExceptions?.map((exception, index) => (
          <div className="mb-1" key={`open-hours-${index}`}>
            <div>{`${exception[0]}, ${exception[1]}`}</div>
          </div>
        ))}
        {exceptionStrings.length > 2 && (
          <button
            className="text-headings text-text-default underline"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? showLessText : showMoreText}
          </button>
        )}
      </>
    );
  } else return <></>;
};
